'use strict';

var utilities = require('shared/utilities/defs/utilities'),
    units = require('shared/utilities/defs/units'),

    factory = require('widget/scripts/lib/api/factory'),
    events = require('widget/scripts/lib/commons/events/defs/events'),

    globalMessageListeners = require('widget/scripts/lib/commons/globalMessageListeners.js');

globalMessageListeners.bootstrap();

window.iVis = {
    Widget: {
        create: function (targetContainer) {
            return factory(targetContainer);
        }
    },
    Utilities: utilities,
    UtilitiesUnits: units,
    Events: events
};

module.exports = window.iVis;



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/widget.js
// module id = 9
// module chunks = 0 1